import { Container, Typography, Box, Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Navigate, Outlet } from 'react-router';
import LoadingMask from './shared/LoadingMask';
import { useAuth } from '../providers/AuthContext';
import APP_ROLES from './AppRoles';

interface ProtectedRouteProps {
  children?: React.ReactNode;
  accqsure?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  accqsure,
}) => {
  const auth = useAuth();

  if (auth.user === undefined) {
    return <LoadingMask />;
  }

  if (auth.user === null) {
    return (
      <Box sx={{ display: 'flex' }}>
        <Container sx={{ padding: '15px' }}>
          <Grid
            container
            spacing={2}
            justifyContent='center'
            alignItems='center'
          >
            <Grid size={12} justifyContent='center' display='flex'>
              <Typography variant='h5'>
                You must login to access this page.
              </Typography>
            </Grid>
            <Grid size={12} display='flex' justifyContent='center'>
              <Button
                onClick={() => {
                  if (auth.user_manager) {
                    auth.user_manager.signinRedirect();
                  }
                }}
                variant='contained'
              >
                Login
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  }

  const isAccqsureAdmin = (auth?.roles || []).includes(APP_ROLES.ADMIN_ACCQSURE);
  if (accqsure && !isAccqsureAdmin) {
    return (
      <Container sx={{ padding: '15px' }}>
        <Grid container spacing={2} justifyContent='center' alignItems='center'>
          <Grid size={12} justifyContent='center' display='flex'>
            <Typography variant='h5'>
              Only AccQsure administrators can access this page
            </Typography>
          </Grid>
        </Grid>
      </Container>
    );
  }

  if (!accqsure && !isAccqsureAdmin) {
    return <Navigate to='/error' />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
